export * from "./templates.component";
